import Vue from 'vue';

export const notifierBus = new Vue();

export const showNotifier = (args) => notifierBus.$emit('show', args);
export const hideNotifier = (args) => notifierBus.$emit('hide', args);
